import MenuIcon from "@mui/icons-material/Menu";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import * as React from "react";
import TileGreenImage from "../../images/tile-green-green.png";
import TileCreamImage from "../../images/tile-cream-cream.png";
import { pallete } from "../../libs/pallete";

import IconCompanyLogo from "../Icon/CompayLogo";

import { useNavigateToTop } from "../../libs/useNavigateToTop";
const drawerWidth = 240;
const navItems = ["Home", "Sites", "Planning", "Resource Lists", "Explorer"];

const navTo = ["/", "/sites", "/planner", "/resourceLists", "/explorer"];

function ListItemLink({ location, title, to, ...props }) {
  const navigate = useNavigateToTop();
  // get the current location
  let loc = location.pathname;
  // remove all slashes
  loc = loc.replace(/\//g, "");
  let linkWithoutSlash = to.replace(/\//g, "");

  // if the current location is the same as the link, then underline
  let textDecoration = loc === linkWithoutSlash ? "underline" : "none";

  // console.log("linkWithoutSlash", linkWithoutSlash);
  return (
    <ListItem
      {...props}
      onClick={() => {
        navigate(to);
      }}
    >
      {/* <Link
        style={{
          // textDecoration: "none",
          color: "unset",
          marginTop: "1rem",
          textDecoration,
          textDecorationThickness: "0.1rem",
          textAlign: "center",
          width: "100%",
        }}
        to={to}
      > */}
      <Typography
        variant="h5"
        style={{ alignSelf: "center", textAlign: "center" }}
      >
        {title}
      </Typography>
      {/* </Link> */}
    </ListItem>
  );
}

function DrawerMenu({ location = window.location, alt = false }) {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  let backgroundImage = !alt ? TileGreenImage : TileCreamImage;
  let fontColor = alt ? pallete.darkNeutral.light : pallete.warm.light;

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      style={{
        color: fontColor,
        backgroundImage: `url(${backgroundImage})`,
        backgroundRepeat: "repeat",
        backgroundSize: "500px 400px",
        height: "100%",
      }}
      sx={{ textAlign: "center" }}
    >
      <IconCompanyLogo style={{ height: "4rem", padding: "1rem" }} />

      <Divider />
      <List>
        {navItems.map((item, index) => (
          <ListItemLink
            location={location}
            title={item}
            key={index}
            to={navTo[index]}
          />
        ))}
      </List>
    </Box>
  );

  const container = document.body;

  return (
    <Box sx={{ display: "flex" }}>
      <IconButton
        color="secondary"
        aria-label="open drawer"
        edge="start"
        onClick={handleDrawerToggle}
        // sx={{ mr: 2, display: { sm: "none" } }}
        sx={{ mr: 2 }}
      >
        <MenuIcon />
      </IconButton>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            // display: { xs: "block", sm: "none" },
            display: "block",
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}

export default DrawerMenu;
